import { jsx as s } from "react/jsx-runtime";
import * as l from "react";
const r = (e) => /* @__PURE__ */ l.createElement("svg", { width: 16, height: 60, viewBox: "0 0 16 60", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ l.createElement("path", { d: "M14.4075 58.3L13.3689 59.5L12.1018 52.8992L9.69266 39.0092L6.41724 39.8127L0 7.41623L8.61306 0.5L11.5071 38.4551L14.7717 37.6579L16 56.4607L15.9828 56.4799L15.9655 56.4991L15.931 56.5374L15.8642 56.6163L14.4032 58.2979L14.4075 58.3Z", fill: "#FF2D5E" })), t = {
  small: "w-[8px] h-[30px]",
  normal: "w-[16px] h-[59px]",
  large: "w-[32px] h-[118px]"
}, n = ({
  className: e,
  size: a = "normal"
}) => {
  const o = t[a] || t.normal;
  return /* @__PURE__ */ s("div", { className: e, children: /* @__PURE__ */ s(r, { className: o }) });
};
export {
  n as FlashSVG
};
